/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const configurator = {
  configurator: {
    header: {
      consistent: 'Consistente',
      complete: 'Completar',
      configId: 'ID de configuração',
      toconfig: 'Configurar',
      editConfiguração: 'Editar configurações',
      displayConfiguração: 'Configurações de exibição',
      resolveIssues: 'Resolver problemas',
      resolveIssue: 'Resolver problema',
      resolveConflitos: 'Resolver conflitos',
      conflictWarning: 'O conflito deve ser resolvido para que continue',
      updateMessage: 'As configurações estão sendo atualizadas em segundo plano',
      conflictsResolved: 'Os conflitos foram resolvidos',
      programaMore: 'Mostre mais',
      programaLess: 'Mostre menos',
      items: '{{count}} artigo',
      items_other: '{{count}} artigos',
      programa: 'programa',
      esconder: 'esconder',
      multipleWarnings: 'Existem várias ressalvas.',
      reviewWarnings: 'Revise estas advertencias',
      multipleErrors: 'Existem vários erros.',
      reviewErrors: 'Revise esses erros',
      kbKeyName: 'Número de Kb',
      kbKeyLogsys: 'Sistema Lógico Kb',
      kbKeyVersion: 'Versão Kb',
      kbKeyBuildNr: 'Número de compilação Kb',
    },
    tabBar: {
      configuration: 'Configuração',
      overview: 'Visão geral',
    },
    notificationBanner: {
      numberOfIssues: '{{count}} O problema deve ser resolvido antes de finalizar a compra.',
      numberOfIssues_other:
        '{{count}} Os problemas devem ser resolvidos antes de finalizar a compra.',
      numberOfConflitos: '{{count}} A disputa deve ser resolvida antes de finalizar a compra.',
      numberOfConflitos_other:
        '{{count}} As disputas devem ser resolvidas antes que o pagamento seja feito.',
    },
    attribute: {
      id: 'IDENTIFICAÇÃO',
      quantity: 'Quantidade',
      caption: 'Atributos',
      notSupported: 'O tipo de atributo não é suportado.',
      requiredAttribute: '{{param}} obrigatório',
      defaultRequiredMessage: 'Insira um valor para o campo obrigatório',
      singleEscolherRequiredMessage: 'Selecione um valor',
      singleEscolherAdicionaritionalRequiredMessage: 'Selecione ou insira um valor',
      multiEscolherRequiredMessage: 'Selecione um ou mais valores',
      // TODO (CXSPA-3392): `wrongNumericFormat` is deprecated and will be removed for the next major release
      wrongNumericFormat:
        'Formatação incorreta, este atributo numérico deve ser inserido de acordo com o padrão {{pattern}}',
      wrongNumericFormatMessage:
        'Digite o número no seguinte formato: {{pattern}}',
      wrongIntervalFormat: 'Insira um valor dentro dos limites indicados',
      deselectionNotPossible:
        'Adicione um produto diferente antes de remover este',
      dropDownEscolherMsg: 'Faça uma seleção',
      noOptionEscolheredMsg: 'Nenhuma opção selecionada',
      notVisibleAttributeMsg: 'Esse atributo não é visível para o usuário',
    },
    button: {
      previous: 'Anterior',
      next: 'Próximo',
      back: 'Atrás',
      mais: 'mais',
      menos: 'menos',
      deselect: 'Desmarque',
      select: 'Escolher',
      add: 'Adicionar',
      remove: 'Eliminar',
      exit: 'Sair Configuração',
      exitMobile: 'Sair',
      cancelConfiguração: 'Cancelar Configuração',
      cancelConfiguraçãoMobile: 'Cancelar',
      filterOverview: 'Filtro',
      filterOverviewWithCount: 'Filtrar ({{numAppliedFilters}})',
    },
    icon: {
      groupCompletar: 'Completar',
      groupIncompleto: 'Incompleto',
      groupConflito: 'Conflito',
      subgroup: 'tem subgrupos',
    },
    priceSummary: {
      basePrice: 'Preço base',
      selectedOptions: 'Opções escolhidas',
      totalPrice: 'Total',
      totalPricePerItem: 'Total por item',
    },
    addToCart: {
      button: 'Adicionar ao carrinho',
      buttonAfterAdicionarToCart: 'Continuar ao carrinho',
      buttonUpdateCart: 'Fato',
      buttonDisplayOnly: 'Fato',
      buttonFechar: 'Fechar',
      confirmation: 'Configuração foi adicionado ao carrinho',
      confirmationUpdate: 'O carrinho foi atualizado com as configurações',
      quantity: 'Quantidade',
    },
    overviewForm: {
      noAttributeHeader: 'Sem resultados',
      noAttributeText: 'Remova o(s) filtro(s) para visualizar o conteúdo da visão geral do Vision',
      itemPrice: 'Preço do item',
    },
    overviewSidebar: {
      menu: 'Menu',
      filter: 'Filtro',
    },
    overviewFiltro: {
      title: 'Escolher Filtros',
      byOption: 'Filtrar por opção',
      byGroup: 'Filtrar por grupo',
      byPrice: 'Opções relevantes para o preço',
      myEscolherions: 'Mis Escolherions',
      removeAll: 'Remover tudo',
      removeAllFiltros: 'Remover tudo Filtros',
      removeByPrice: 'Eliminar Price-Relevant Filtro',
      removeMyEscolherions: 'Eliminar Mis Escolherions Filtro',
      removeByGroup: 'Eliminar Group Filtro for group {{group}}',
    },
    group: {
      general: 'Geral',
      conflictHeader: 'Resolver conflitos',
      conflictGroup: 'Conflito por {{attribute}}',
    },
    conflict: {
      suggestionTitle: 'Sugestão {{number}}:',
      suggestionText: 'Change value for "{{ attribute }}"',
      viewConflitoDetails: 'Conflito detectado - Ver detalhes',
      conflictDetected: 'Conflito detectado',
      viewConfiguraçãoDetails: 'View In Configuração',
    },
    restartDialog: {
      title: 'Unfinished Configuração',
      description:
        'Há uma configuração inacabada de uma sessão anterior. Gostaria de retomar ou iniciar uma nova configuração?',
      restartButton: 'Recomeçar',
      resumeButton: 'Retomar',
    },
    a11y: {
      configureProduct: 'Configurar produto',
      cartEntryBundleInfo: 'Existe um elemento ',
      cartEntryBundleInfo_other: 'Existem {{items}} itens ',
      cartEntryBundleName: 'Artigo {{ name }}',
      cartEntryBundleNameWithQuantity:
        'Artigo {{ name }} item quantidade {{quantity}}',
      cartEntryBundleNameWithPrice: 'Artigo {{ name }} item price {{price}}',
      cartEntryBundle:
        'Artigo {{ name }} preço do item {{price}} quantidade do item {{quantity}}',
      cartEntryInfoIntro:
        'O produto tem os seguintes atributos e valores selecionados:',
      cartEntryInfo: 'O atributo {{ attribute }} tem o valor {attribute}} selecionado',
      nameOfAttribute: 'Nome do atributo',
      valueOfAttribute: 'Valor do atributo {{ attribute }}',
      forAttribute: '{{ value }} para o atributo {value}}',
      valueOfAttributeFull: 'Valor {{ value }} do atributo {value}}',
      valueOfAttributeFullWithPrice:
        'Valor de Escolha {{ value }} do atributo {{ attribute }}, Surcharge {{ price }}',
      selectedValueOfAttributeFull:
        'Valor de Escolha  {{ value }} del atributo {{ attribute }}',
      selectedValueOfAttributeFullWithPrice:
        'Valor de Escolha  {{ value }} del atributo {{ attribute }}, Surcharge {{ price }}',
      readOnlyValueOfAttributeFullWithPrice:
        'Valor somente leitura {{ value }} do atributo {{ attribute }}, Sobretaxa {{ price }}',
      readOnlyValueOfAttributeFull:
        'Valor somente leitura {{ value }} do atributo {{ attribute }}',
      valueOfAttributeBlank: 'Valor do atributo {{ attribute }} is blank',
      value: 'Valor  {{ value }}',
      attribute: 'Atributo {{ attribute }}',
      requiredAttribute: 'O atributo {{param}} é obrigatório',
      listOfAtributosAndValues: 'Lista de atributos e seus valores:',
      editAtributosAndValues: 'Edite os valores dos atributos:',
      group: '{{ group }} grupo de atributos',
      itemOfAttributeEscogered:
        'O elemento {{ item }} do atributo {{ attribute }} foi selecionado. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredWithPrice:
        'O elemento {{ item }} do atributo {{ attribute }} foi selecionado, Acréscimo {{ price }}. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredPressToUnselect:
        'O elemento {{ item }} do atributo {{ attribute }} foi selecionado. Pressione o botão para desfazer a seleção. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredPressToUnselectWithPrice:
        'O elemento {{ item }} do atributo {{ attribute }} foi selecionado, Acréscimo {{ price }}. Pressione o botão para desfazer a seleção. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeUnselected:
        'O elemento {{ item }} do atributo {{ attribute }} não está selecionado. Pressione o botão para selecionar. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeUnselectedWithPrice:
        'O elemento {{ item }} do atributo {{ attribute }} não está selecionado, Acréscimo {{ price }}. Pressione o botão para selecionar. {{ itemIndex }} de {{ itemCount }}',
      selectNoItemOfAttribute:
        'Para não selecionar nenhum elemento do atributo {{ attribute }}, pressione o botão. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttribute: 'Elemento de atributo {{ attribute }}',
      itemOfAttributeFull: 'Elemento {{ item }} do atributo {{ attribute }}',
      itemOfAttributeFullWithPrice:
        'Elemento  {{ item }}} de tributo {{ attribute }}, Recargo {{ price }}',
      itemOfAttributeFullWithQuantity:
        'Elemento  {{ item }} of tributo {{ attribute }}, Quantidade {{ quantity }}',
      itemOfAttributeFullWithPriceAndQuantity:
        'Elemento  {{ item }} of tributo {{ attribute }}, Quantidade {{ quantity }}}, Surcharge {{ price }}',
      itemDescription: 'Descrição do item {{ item }}',
      listbox: 'Caixa de listagem com valores {{ count }}.',
      valueSurcharge: 'Sobretaxa por valor',
      conflictDetected:
        'Conflito detectado! Verifique os conflitos no topo da lista de grupos.',
      conflictsInConfiguração:
        'Há conflitos na configuração. Número de conflitos: {{ numberOfConflicts }}, Escolher para mais detalhes.',
      listOfGroups: 'Lista de grupos',
      inListOfGroups: 'Você está na lista de grupos',
      groupName: 'Grupo {{ group }}',
      groupAtrás: 'Você está em um subgrupo. Escolher retornar.',
      conflictAtrás:
        'Você está no solucionador de conflitos. Escolha voltar ou selecione as guias a seguir para resolver conflitos.',
      iconConflito: 'O grupo tem conflitos.',
      iconIncompleto: 'O grupo tem atributos necessários sem valores selecionados.',
      iconCompletar: 'O grupo está completo.',
      iconSubGroup: 'O grupo tem um subgrupo.',
      next: 'Vá para o próximo grupo.',
      previous: 'Vá para o grupo anterior.',
      showMoreProductInfo:
        'Mostre mais informações sobre o produto {{ product }} ou continue com a configuração.',
      showLessProductInfo:
        'Mostre menos informações para o produto {{ product }} ou continue com a configuração.',
      productName: 'Nome do produto',
      productCode: 'Código do produto',
      productDescription: 'Descrição do produto',
      kbKeyName: 'Número de Kb {{name}}',
      kbKeyLogsys: 'Kb {{logsys}} Sistema Lógico',
      kbKeyVersion: 'Versão Kb {{version}}',
      kbKeyBuildNr: 'Número de compilação Kb {{number}}',
      configurationPage: 'Está na página de configurações.',
      configurationPageLink: 'Vá para a página de configurações.',
      overviewPage:
        'Ele pode ser encontrado na página de visão geral. Verifique os atributos selecionados e seus valores usando o modo de leitura do leitor de tela.',
      overviewPageLink: 'Vá para a página de visão geral das configurações.',
      navigateToConflito:
        'Siga o link para obter mais detalhes sobre o conflito de atributos {{}}.',
      numericIntervalStandard:
        'Insira um valor entre {{ minValue }} e {{ maxValue }}',
      numericIntervalStandardOpen: '(Os pontos de conexão não estão incluídos)',
      numericIntervalStandardLowerEndpointNotIncluded:
        '(O ponto final inferior não está incluído)',
      numericIntervalStandardUpperEndpointNotIncluded:
        '(O ponto final mais alto não está incluído)',
      numericInfiniteIntervalMinValueIncluded:
        'Insira um valor maior ou igual a{{ value }}',
      numericInfiniteIntervalMinValue: 'Insira um valor maior que {{ value }}',
      numericInfiniteIntervalMaxValueIncluded:
        'Insira um valor menor ou igual a{{ value }}',
      numericInfiniteIntervalMaxValue: 'Insira um valor menor que {{ value }}',
      numericIntervalSingleValue: 'Digite {{ value }}',
      combinedIntervalsText: '{{ combinedInterval }} o {combinedInterval}}',
      additionalValue: 'Você também pode inserir um valor adicional.',
      addToCartPrices:
        'Preço base {{basePrice}}, Opções escolhidas {{selectedOptions}}, Total Price {{totalPrice}}',
      filterOverview: 'Abra o menu de filtro Visão geral das configurações',
      filterOverviewWithCount:
        'Abra o menu Filtros de resumo de configuração - Filtros ativos',
      closeFiltroMenu:
        'Feche o menu de filtros de visão geral das configurações e aplique os filtros selecionados',
      filterOverviewByPrice:
        'Resumo das configurações de filtro por opções relevantes para o preço',
      filterOverviewByMySelections:
        'Visão geral das configurações de filtro por suas seleções',
      filterOverviewByGroup:
        'Visão geral das configurações de filtro por grupo {{groupName}}',
      closeConflitoSolverModal: 'Modal do solucionador de conflitos de data',
      closeRestartDialog:
        'Fechar the "Unfinished Configuração" dialog and navigate back to the product details page',
    },
    variantCarousel: {
      title: 'Versões pré-configuradas',
    },
  },
};
